/**
 * Inloggningstoken från API:et. Ligger i sessionStorage: den försvinner när
 * fliken stängs och delas inte mellan flikar, vilket räcker för ett CMS som
 * används i korta pass. En cookie hade varit otillgänglig för JavaScript, men
 * blockeras av webbläsare när API:et ligger på en annan domän än frontend.
 */
const KEY = 'nbo-admin-token';

export function getToken(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string): void {
  try {
    sessionStorage.setItem(KEY, token);
  } catch {
    /* Privat läge kan neka lagring – inloggningen gäller då bara sidvisningen. */
  }
}

export function clearToken(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* Se ovan. */
  }
}
